import { CurrencyDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getCurrency(): Observable<CurrencyDto[]> {
    return this.http.get<CurrencyDto[]>(this.url + 'currency');
  }

  createCurrency(data: CurrencyDto[]): Observable<CurrencyDto[]> {
    return this.http.post<CurrencyDto[]>(this.url + 'currency', data);
  }
  getSingleCurrency(id: string): Observable<any> {
    return this.http.get(this.url + 'currency/' + id);
  }

  updateCurrency(data: CurrencyDto[]): Observable<CurrencyDto[]> {
    return this.http.post<CurrencyDto[]>(this.url + 'currency/update', data);
  }

  deleteCurrency(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('currency', ids.join(', '));
    return this.http.delete(this.url + 'currency', httpOptions);
  }
}
